import {
  ADD_FILE,
  CHANGE_FIELD,
  REMOVE_FILE,
  SET_ERRORS,
  SET_IMPORT_REQUEST,
  REMOVE_ERRORS
} from '../actions/form';

export default function (state = {}, action) {
  switch (action.type) {
  case ADD_FILE: {
    const importRequest = { ...state.importRequest };
    const files = importRequest.files || [];
    return { ...state, importRequest: { ...importRequest, files: [...files, action.file] } };
  }
  case CHANGE_FIELD: {
    const { field, value } = action;
    const importRequest = { ...state.importRequest };

    importRequest[field] = value;
    if (field === 'source' && value !== 'other') {
      importRequest.customSourceName = '';
    }

    return { ...state, importRequest };
  }
  case REMOVE_FILE: {
    const importRequest = { ...state.importRequest };
    let files = importRequest.files || [];

    if (action.file.id) {
      files = files.filter(file => file.id !== action.file.id);
      files.push({ ...action.file, _destroy: true });
    } else {
      files = files.filter(file => file.id || file.uploadId !== action.file.uploadId);
    }

    return { ...state, importRequest: { ...importRequest, files } };
  }
  case SET_ERRORS:
    return { ...state, errors: action.errors };
  case REMOVE_ERRORS:
    return { ...state, errors: null };
  case SET_IMPORT_REQUEST:
    return { ...state, importRequest: action.importRequest };
  default:
    return state;
  }
}
